import json from './sprite.js';

export default {
    handle: 'ENG_SPS7-SpiltJuice',
    label: 'en_SPS7-SpiltJuice_225002329',
    json,
};
